module.exports = __webpack_public_path__ + "img/instagram.f3748990.svg";